<template>
  <!--TODO category search, give users some hints about what to search-->
  <div ref="save-extraction-form">
    <transition name="modal">
      <div class="modal-mask eh-popup-overlay">
        <div class="modal-wrapper">
          <div class="modal-container eh-popup-panel">
              <p class="modal-close">
                <button class="btn btn-danger" @click="$emit('close')">x</button>
              </p>
            <!-- modal 1: main -->
            <save-modal-main :modalBehavior="modalBehavior" @handleSearchNpi="handleSearchNpi"
                             @selectNpi="selectNpi"
                             @slideModalTo="slideModalTo"
                             @close="close"></save-modal-main>

            <!-- modal 2: NPI Search -->
            <template v-if="isNpiSearchResultsLoaded">
              <save-modal-npi-search :modalBehavior="modalBehavior" :npiSearchResults="npiSearchResults"
                                     :searchNpiForm="searchNpiForm" @selectNpi="selectNpi"
                                     @slideModalTo="slideModalTo"></save-modal-npi-search>
            </template>

            <!-- modal 3: category search -->
            <save-modal-category-search :modalBehavior="modalBehavior"
                                        @slideModalTo="slideModalTo"
                                        @selectCategory="selectCategory">
            </save-modal-category-search>

            <!-- modal 4: (optional) procedure search -->
            <save-modal-procedure-search :modalBehavior="modalBehavior"
                                         @selectProcedure="selectProcedure"
                                         @handleSaveExtraction="handleSaveExtraction"
                                         @close="close"
                                         @slideModalTo="slideModalTo">
            </save-modal-procedure-search>

            <!-- modal 5: report date -->
            <!--<save-modal-report-date :modalBehavior="modalBehavior" @slideModalTo="slideModalTo" @close="close"-->
                                    <!--@handleSaveExtraction="handleSaveExtraction"></save-modal-report-date>-->

          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  import {searchNpiViaRegistry, resolveNpiId, searchCategory} from '@/api/pdfApi';
  import {mapGetters, mapActions} from 'vuex';
  import SaveModalMain from './save-modal/SaveModalMain';
  import SaveModalNpiSearch from './save-modal/SaveModalNpiSearch';
  import SaveModalCategorySearch from './save-modal/SaveModalCategorySearch';
  import SaveModalProcedureSearch from './save-modal/SaveModalProcedureSearch';
import { h } from 'vue';

  export default {
    name: "PdfExtractionSaveModal",
    props: {
      extractionInfos: Array,
      dob: {
        type: String,
        default : ''
      },
      reportDate: {
        type: String,
        default: ''
      },
      pdfId: {
        type: Number,
        required: true
      }
    },
    components: {
      'save-modal-main': SaveModalMain,
      'save-modal-npi-search': SaveModalNpiSearch,
      'save-modal-category-search': SaveModalCategorySearch,
      'save-modal-procedure-search': SaveModalProcedureSearch,
    },
    data() {
      return {
        categoryDesc: '',
        npiSearchResults: Array,
        npiSelected: null,
        categorySelected: null,
        procedureSelected: null,
        isNpiSearchResultsLoaded: false,

        modalBehavior: {
          showModalMain: true,
          showModalNpiSearch: false,
          showModalCategorySearch: false,
          showModalProcedureSearch: false,
          showModalFinish: false,
        },
        searchNpiForm: {
          first: '',
          last: '',
          business: '',
          phone: '',
          specialty: '',
          npi: '',
          otherId: ''
        },
      }
    },
    /*
    computed: {
      ...mapGetters('login/pdf', {
        pdfId: 'getPdfId',
      }),
    },*/

    methods: {
      ...mapActions('login/pdf', [
        'saveExtraction'
      ]),
      handleSaveExtraction() {
        // Document-type step is skipped; a procedure is required to save.
        if (!this.procedureSelected) {
          alert('Your report should have a procedure.');
          return;
        }

        // show spinning to indicate progress,
        let loader = this.$loading.show({},{
          after: () => h('div',{},`Saving report...`)
        });

        let requestParams = {
          id: this.pdfId,
          date: this.reportDate,
          npi: this.npiSelected,
          extractions: this.extractionInfos
        };
        if (this.procedureSelected) {
          requestParams.procedure = this.procedureSelected;
        }


        /* NOTE:
          partial extraction has a format of
            source: {
              selections: Array
              rotation: Number
              referencedPages: Array
            }

          if adding a feature to extract a whole page,
          make sure the source object is of the following format:
          source: {
            pageNumber: Number // page of interest
            rotation: Number //
            scale: Number // may not be needed since the backend has a hard code value
          }
        */
        this.saveExtraction(requestParams)
            .then((id) => {
              this.$swal({
                type: 'success',
                title: 'Extraction saved',
                text: 'You can go to the Reports page to see the report.'
              }).then(() => {
                window.location.reload()
              });

              this.$emit('close');

            })
            .catch((err) => {
              console.error(err);
            })
            .finally(() => {
              loader.hide();
            });


      },
      handleSearchNpi(searchNpiForm, nextModal) {
        this.searchNpiForm = searchNpiForm;
        const last = (this.searchNpiForm.last || '').trim();
        const npi = (this.searchNpiForm.npi || '').trim();
        if (!last && !npi) {
          return;
        }
        const loader = this.$loading.show({}, {
          after: () => h('div', {}, 'Searching provider...'),
        });
        searchNpiViaRegistry(this.searchNpiForm)
          .then((npis) => {
            this.npiSearchResults = npis;
            this.isNpiSearchResultsLoaded = true;
            this.slideModalTo(nextModal);
          })
          .catch((err) => {
            this.npiSearchResults = [];
            this.isNpiSearchResultsLoaded = true;
            this.slideModalTo(nextModal);
            console.error(err);
          })
          .finally(() => {
            loader.hide();
          });
      },
      // Can't pass by ref? have to define explicit modal transition
      slideModalTo(modal) {
        // Provider must be selected before leaving the provider steps.
        if (modal === 'procedureSearch' && !this.npiSelected) {
          this.$swal({
            type: 'warning',
            title: 'Select a provider',
            text: 'Choose a provider from the list and wait for it to link before continuing.',
          });
          return;
        }
        switch (modal) {
          case 'main':
            this.modalBehavior.showModalMain = true;
            this.modalBehavior.showModalNpiSearch = false;
            this.modalBehavior.showModalCategorySearch = false;
            this.modalBehavior.showModalProcedureSearch = false;
            break;

          case 'npiSearch':
            this.modalBehavior.showModalMain = false;
            this.modalBehavior.showModalNpiSearch = true;
            this.modalBehavior.showModalCategorySearch = false;
            this.modalBehavior.showModalProcedureSearch = false;
            break;

          // Document-type step kept in the component tree but no longer visited.
          case 'categorySearch':
            this.slideModalTo('procedureSearch');
            break;

          case 'procedureSearch':
            this.categorySelected = null;
            this.procedureSelected = null;
            this.modalBehavior.showModalMain = false;
            this.modalBehavior.showModalNpiSearch = false;
            this.modalBehavior.showModalCategorySearch = false;
            this.modalBehavior.showModalProcedureSearch = true;
            this.modalBehavior.showModalFinish = false;
            break;

          case 'finish':
            this.modalBehavior.showModalProcedureSearch = false;
            this.modalBehavior.showModalFinish = true;
            break;


        }
      },
      close() {
        this.$emit('close');
      },
      async selectNpi(npiOrId) {
        if (npiOrId != null && typeof npiOrId === 'object') {
          const npiNumber = npiOrId.npinumber || npiOrId.id;
          if (!npiNumber) {
            return;
          }
          const loader = this.$loading.show({}, {
            after: () => h('div', {}, 'Linking provider...'),
          });
          try {
            const internalId = await resolveNpiId(npiNumber, npiOrId);
            if (!internalId) {
              this.$swal({
                type: 'error',
                title: 'Could not link provider',
                text:
                  'Unable to add this provider. Verify the NPI number and try again.',
              });
              return;
            }
            this.npiSelected = internalId;
          } catch (err) {
            console.error(err);
            this.$swal({
              type: 'error',
              title: 'Could not link provider',
              text: 'Unable to resolve the selected NPI. Please try again.',
            });
          } finally {
            loader.hide();
          }
          return;
        }
        this.npiSelected = npiOrId;
      },
      selectCategory(category) {
        this.categorySelected = category;
      },
      selectProcedure(procedure) {
        this.procedureSelected = procedure;
      }

    }

  }
</script>

<style scoped lang="scss">
  /* Layout only — backdrop/z-index + surface/border/radius from brand-ds
     (.eh-popup-overlay / .eh-popup-panel). Replaces modules/modal chrome. */
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    position: relative;
    width: 60vw;
    min-height: 80vh;
    margin: 0 auto;
    padding: 10px 20px;
    transition: all 0.3s ease;
  }

  p {
    margin: 0;
  }
  .modal-close {
    position: absolute;
    top: 10px;
    left: 20px;
  }
  .btn-danger {
    font-size: 0.8em;
    padding: 5px 11px;
    border-radius: 50%;
  }

  @media only screen and (max-width: 768px) {
    .modal-container {
      width: 100%;
    }
  }
</style>